webshop.ProductGrid = class {
	/* Options:
		- items: Items
		- settings: Webshop Settings
		- products_section: Products Wrapper
		- preference: If preference is not grid view, render but hide
*/
	constructor(options) {
		Object.assign(this, options);

		if (this.preference !== "Grid View") {
			this.products_section.addClass("hidden");
		}

		// Load-more (PIT-TASK-2027-000135): appended batches must extend the
		// grid instead of replacing it.
		if (!this.append_mode) {
			this.products_section.empty();
		}

		this.make();
	}

	make() {
		let me = this;
		let html = ``;

		// Fixed grid card width/height in px (PIT-TASK-2027-000305): when a
		// width is set in Webshop Settings, the grid rows wrap fixed-width
		// cards so the number of cards per row derives from the card width.
		// A height fixes the card height. 0 = default Bootstrap cols / natural
		// card height.
		const card_size = this.settings && parseInt(this.settings.custom_grid_card_size) || 0;
		const card_height = this.settings && parseInt(this.settings.custom_grid_card_height) || 0;
		// Grid card image WRAPPER height (PIT-TASK-2027-000310): a fixed height
		// for the image box only (not the card). 0 = default image box height.
		const card_img_height = this.settings && parseInt(this.settings.custom_grid_image_wrapper_height) || 0;
		const col_class = card_size > 0
			? "ws-grid-card item-card"
			: "col-6 col-md-4 col-lg-3 item-card";
		if (card_size > 0 || card_height > 0) {
			if (!this.products_section.hasClass("ws-grid-card-size")) {
				this.products_section.addClass("ws-grid-card-size");
			}
			if (card_size > 0) {
				this.products_section[0].style.setProperty("--ws-card-width", card_size + "px");
			}
			if (card_height > 0) {
				this.products_section[0].style.setProperty("--ws-card-height", card_height + "px");
			}
		}
		// Image wrapper height is independent of the card width/height settings.
		if (card_img_height > 0) {
			if (!this.products_section.hasClass("ws-card-img-height")) {
				this.products_section.addClass("ws-card-img-height");
			}
			this.products_section[0].style.setProperty("--ws-card-img-height", card_img_height + "px");
		}

		this.items.forEach(item => {
			// Image Only mood image (PIT-TASK-2027-000218): bare full-image
			// card, no link, no body.
			if (item.custom_image_only) {
				html += me.get_image_only_card_html(item, col_class);
				return;
			}

			let title = item.web_item_name || item.item_name || item.item_code || "";
			title =  title.length > 90 ? title.substr(0, 90) + "..." : title;

			html += `<div class="${ col_class }"><div class="card text-left">`;
			html += me.get_image_html(item, title);
			html += me.get_card_body_html(item, title, me.settings);
			html += `</div></div>`;
		});

		let $product_wrapper = this.products_section;
		$product_wrapper.append(html);

		this.bind_qty_events();
	}

	bind_qty_events() {
		// Load-more (PIT-TASK-2027-000135): the section is emptied on every
		// re-render, which also drops the delegated handlers. Rebind safely
		// from a namespace that is .off()'d first.
		this.products_section.off("input.wsQty click.wsQty");
		this.products_section.on("input.wsQty", ".item-qty-area .item-qty", (event) => {
			let currentValue = event.target.value;
			let validValue = currentValue.replace(/[^0-9]/g, "");
			event.target.value = validValue;
		});

		this.products_section.on("click.wsQty", ".item-qty-area .up-qty", (event) => {
			let item_qty = $(event.target).closest(".item-qty-area").find(".item-qty");
			let step = parseInt(item_qty.data("lot-size")) || 1;
			let currentValue = parseInt(item_qty.val()) || 0;
			item_qty.val(currentValue + step);
		});

		this.products_section.on("click.wsQty", ".item-qty-area .dwn-qty", (event) => {
			let item_qty = $(event.target).closest(".item-qty-area").find(".item-qty");
			let step = parseInt(item_qty.data("lot-size")) || 1;
			let minQty = parseInt(item_qty.data("min-qty")) || 1;
			let currentValue = parseInt(item_qty.val()) || 0;
			item_qty.val(Math.max(currentValue - step, minQty));
		});
	}

	get_image_html(item, title) {
		let image = item.website_image;
		const ratio_class = webshop.get_image_ratio_class ? webshop.get_image_ratio_class(this.settings) : "";
		const badge_html = webshop.get_new_badge_html ? webshop.get_new_badge_html(item) : "";
		const discount_badge_html = webshop.get_discount_badge_html ? webshop.get_discount_badge_html(item) : "";
		// Detail page toggle (PIT-TASK-2027-000166): no link when disabled
		const item_link = webshop.get_item_link ? webshop.get_item_link(item, this.settings) : `/${ item.route || '#' }`;

		// Wishlist icon lives INSIDE the image container now (PIT-TASK-2027-000135):
		// the image is edge-to-edge, so an icon positioned on the card body
		// would float on the photo area.
		const wish_html = (!item.has_variants && this.settings && this.settings.enable_wishlist)
			? this.get_wishlist_icon(item) : "";

		if (image) {
			const img_html = `<img itemprop="image" class="card-img" src="${ image }" alt="${ title }"
					loading="lazy">`;
			return `
				<div class="card-img-container${ ratio_class }">
					${ badge_html }
					${ discount_badge_html }
					${ wish_html }
					${ item_link
						? `<a href="${ item_link }" style="text-decoration: none;">${ img_html }</a>`
						: img_html }
				</div>
			`;
		} else {
			const no_image_html = `<div class="card-img-top no-image">${ frappe.get_abbr(title) }</div>`;
			return `
				<div class="card-img-container${ ratio_class }">
					${ badge_html }
					${ discount_badge_html }
					${ wish_html }
					${ item_link
						? `<a href="${ item_link }" style="text-decoration: none;">${ no_image_html }</a>`
						: no_image_html }
				</div>
			`;
		}
	}

	get_image_only_card_html(item, col_class) {
		// Image Only mood image (PIT-TASK-2027-000218): same card shell as
		// the product cards, but ONLY the image — spanning the whole card,
		// no title, no price, no cart controls, no link to a detail page.
		const ratio_class = webshop.get_image_ratio_class ? webshop.get_image_ratio_class(this.settings) : "";
		const image = item.website_image;
		// `ws-mood-image` = lightbox trigger (PIT-TASK-2027-000342); the img is
		// role="button"/tabindex so it is reachable and openable via keyboard too.
		const img_html = image
			? `<img itemprop="image" class="card-img ws-mood-image" src="${ image }" alt="${ item.web_item_name || '' }" loading="lazy" role="button" tabindex="0" aria-label="${ __("Enlarge image") }">`
			: `<div class="card-img-top no-image">${ frappe.get_abbr(item.web_item_name || '') }</div>`;
		return `
			<div class="${ col_class }"><div class="card text-left ws-image-only-card${ item.custom_fill_image ? ' ws-image-fill-card' : '' }">
				<div class="card-img-container${ ratio_class }">
					${ img_html }
				</div>
			</div></div>
		`;
	}

	get_card_body_html(item, title, settings) {
		let body_html = `
			<div class="card-body text-left card-body-flex" style="width:100%">
				<div style="margin-top: 0; display: flex;">
		`;
		// Item number without label, directly above the item name
		body_html += `<div class="flex-1 min-width-0">`;
		if (settings.custom_show_item_code) {
			body_html += `<div class="product-code-plain">${ item.item_code || '' }</div>`;
		}
		body_html += this.get_title(item, title);
		body_html += `</div>`;

		body_html += `</div>`;

		if (settings.custom_show_item_group) {
			body_html += `<div class="product-category" itemprop="name">${ item.item_group_display || item.item_group || '' }</div>`;
		}

		// Sold Out (PIT-TASK-2027-000358 adjustment 1): a flagged item shows
		// no price in the card at all (the Custom ProductGrid override in
		// custom/webshop_grid.js carries the same guard).
		if (item.formatted_price && !item.custom_sold_out) {
			body_html += this.get_price_html(item);
		}

		body_html += this.get_stock_availability(item, settings);
		body_html += this.get_bottom_row_html(item, settings);
		body_html += `</div>`;

		return body_html;
	}

	// Short description + cart controls in one bottom row (PIT-TASK-2027-000141
	// adjustment): description on the left, qty + add-to-cart on the right,
	// pinned to the bottom of the card (margin-top: auto via CSS).
	get_bottom_row_html(item, settings) {
		const cart_row = this.get_cart_action_row(item, settings);
		const desc = item.short_description
			? `<div class="ws-short-desc">${ item.short_description }</div>` : ``;
		if (!desc && !cart_row) return ``;
		return `<div class="ws-bottom-row">${ desc }${ cart_row }</div>`;
	}

	get_title(item, title) {
		// Detail page toggle (PIT-TASK-2027-000166): no link when disabled
		const item_link = webshop.get_item_link ? webshop.get_item_link(item, this.settings) : `/${ item.route || '#' }`;
		// Item's custom_additional_1 under the item name (PIT-TASK-2027-000308)
		const additional_1_html = webshop.get_custom_additional_1_html
			? webshop.get_custom_additional_1_html(item, this.settings) : "";
		const title_html = `
			<div class="product-title" itemprop="name">
				${ title || '' }
			</div>
			${ additional_1_html }
		`;
		if (!item_link) {
			return title_html;
		}
		return `
			<a href="${ item_link }" style="text-decoration: none; flex: 1;">
				${ title_html }
			</a>
		`;
	}

	get_wishlist_icon(item) {
		let icon_class = item.wished ? "wished" : "not-wished";
		return `
			<div class="like-action ${ item.wished ? "like-action-wished" : ''}"
				data-item-code="${ item.item_code }">
				<svg class="icon sm">
					<use class="${ icon_class } wish-icon" href="#icon-heart"></use>
				</svg>
			</div>
		`;
	}

	get_price_html(item) {
		let price_html = `
			<div class="product-price" itemprop="offers" itemscope itemtype="https://schema.org/AggregateOffer">
				${ item.formatted_price || '' }
		`;

		if (item.formatted_mrp) {
			price_html += `
				<small class="striked-price">
					<s>${ item.formatted_mrp ? item.formatted_mrp.replace(/ +/g, "") : "" }</s>
				</small>
			`;
		}
		price_html += `</div>`;
		return price_html;
	}

	get_stock_availability(item, settings) {
		// Sold Out toggle (PIT-TASK-2027-000358): an explicitly flagged
		// item is not for sale — the availability line says so and wins
		// over every stock/dispatcher hint below (the prices stay).
		if (item.custom_sold_out) {
			// Adjustment 2 (PIT-TASK-2027-000358): marker classes for the
			// card CSS that reserves the space of the price block this card
			// no longer renders (webshop_cart.scss) — flags set server-side
			// (api.py) with the same conditions the price renderers use, so
			// guest cards keep the previous layout.
			const reserve = `${ item.ws_reserve_bulk_prices ? ' ws-reserve-bulk-prices' : '' }${ item.ws_reserve_single_price ? ' ws-reserve-single-price' : '' }`;
			return `
				<span class="out-of-stock ws-sold-out mb-2 mt-1${ reserve }">
					${ __("Sold Out") }
				</span>
			`;
		}
		// "Sofort lieferbar" on the overview card for items with stock
		// (PIT-TASK-2027-000280) — mirrors the detail page's dispatcher
		// line, independent of show_stock_availability.
		if (!item.has_variants && item.is_stock && item.in_stock && !item.delivery_on_request) {
			return `
				<span class="in-stock in-green has-stock mb-2 mt-1">
					${ __("Currently available") }
				</span>
			`;
		}
		// Next possible delivery date (PIT-TASK-2027-000324 adjustment 1):
		// the dispatcher's earliest deliverable date for items that are
		// NOT currently in stock, rendered in the SAME availability line
		// as "Currently available" / "Delivery date on request" (mirrors
		// the detail page's "Earliest delivery date" line). The value is
		// formatted server-side so it matches the shop's other dates.
		if (
			!item.has_variants &&
			item.is_stock &&
			!item.in_stock &&
			!item.delivery_on_request &&
			item.next_delivery_date_formatted
		) {
			return `
				<span class="next-delivery-date text-muted mb-2 mt-1">
					${ __("Earliest delivery date") }: ${ item.next_delivery_date_formatted }
				</span>
			`;
		}
		// "Liefertermin auf Anfrage" (PIT-TASK-2027-000324): rendered on the
		// SAME position as "Currently available" — the availability line in
		// the card body (below the title / price), instead of the
		// cart-action row where it used to sit. Both hints are mutually
		// exclusive, so they never appear at the same time.
		if (!item.has_variants && item.delivery_on_request) {
			return `
				<span class="delivery-on-request text-muted mb-2 mt-1">
					${ __("Delivery date on request") }
				</span>
			`;
		}
		if (settings.show_stock_availability && !item.has_variants) {
			if (item.on_backorder) {
				return `
					<span class="out-of-stock mb-2 mt-1" style="color: var(--primary-color)">
						${ __("Available on backorder") }
					</span>
				`;
			} else if (!item.in_stock) {
				return `
					<span class="out-of-stock mb-2 mt-1">
						${ __("Out of stock") }
					</span>
				`;
			}
		}
		return ``;
	}

	get_cart_action_row(item, settings) {
		if (item.has_variants) {
			// Variants can only be chosen on the detail page — without it,
			// the Explore button has no target (PIT-TASK-2027-000166).
			if (webshop.detail_page_enabled && !webshop.detail_page_enabled(settings)) {
				return ``;
			}
			return `
				<div class="mt-3">
					<a href="/${ item.route || '#' }">
						<div class="btn btn-sm btn-explore-variants">
							${ __("Explore") }
						</div>
					</a>
				</div>
			`;
		}

		// Card cart controls (PIT-TASK-2027-000379): when the Webshop Settings
		// toggle is on, the card renders no qty spinner and no add-to-cart
		// button at all (the cart row is omitted, not hidden via CSS).
		if (webshop.card_add_to_cart_hidden && webshop.card_add_to_cart_hidden(settings)) {
			return ``;
		}

		if (!settings.enabled) {
			return ``;
		}

		// Sold Out toggle (PIT-TASK-2027-000358): the item stays published
		// with its prices, but the cart controls are rendered disabled —
		// shopping_cart.js skips clicks on .ws-sold-out-btn and
		// cart.update_cart() rejects the item server-side.
		const sold_out = !!item.custom_sold_out;
		if (!sold_out && !settings.allow_items_not_in_stock && !item.in_stock) {
			return ``;
		}

		// "Liefertermin auf Anfrage" (PIT-TASK-2027-000344): no stock and no
		// open PO, but the item CAN be ordered — the dispatcher skips it at
		// order submit (custom_ignore_stock_dispatcher) instead of rejecting
		// the whole order. So the add-to-cart controls stay visible; the
		// availability line above still shows "Delivery date on request"
		// (PIT-TASK-2027-000324).

		return `
			<div class="cart-action-row mt-3">
				<div class="item-qty-area">
					<div class="input-group number-spinner">
						<span class="input-group-prepend d-sm-inline-block">
							<button class="item-qty-btn dwn-qty" data-dir="dwn"${ sold_out ? " disabled" : "" }>
								&ndash;
							</button>
						</span>
						<input class="form-control text-center item-qty"
							value="${ item.min_qty || 1 }"
							min="${ item.min_qty || 1 }"
							step="${ item.lot_size || 1 }"
							data-item-code="${ item.item_code }"
							data-min-qty="${ item.min_qty || 1 }"
							data-lot-size="${ item.lot_size || 1 }"${ sold_out ? " disabled" : "" }>
						<span class="input-group-append d-sm-inline-block">
							<button class="item-qty-btn up-qty" data-dir="up"${ sold_out ? " disabled" : "" }>
								+
							</button>
						</span>
					</div>
				</div>
				<div id="${ item.name }" class="btn btn-sm btn-primary btn-add-to-cart-list${ sold_out ? " disabled ws-sold-out-btn" : "" }"
					data-item-code="${ item.item_code }"${ sold_out ? ' data-sold-out="1" aria-disabled="true"' : "" }
					title="${ sold_out ? __("Sold Out") : (settings.enable_checkout ? __("Add to Cart") : __("Add to Quote")) }">
					<svg class="icon icon-md" viewBox="0 0 24 24" fill="none">
						<path d="M3 6h17" stroke="currentColor" stroke-miterlimit="10"></path>
						<path d="M20 19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6l3.4-3h10.2L20 6v13z" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"></path>
						<path d="M15.582 10c0 2.29-1.8 4.09-4.091 4.09A4.051 4.051 0 0 1 7.4 10" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
						<circle cx="15.6" cy="10" r=".5" stroke="currentColor"></circle>
						<circle cx="7.3" cy="10" r=".5" stroke="currentColor"></circle>
					</svg>
					${ item.in_cart ? `<span class="ws-cart-count-badge" data-item-code="${ item.item_code }">${ item.in_cart_qty }</span>` : '' }
				</div>
			</div>
		`;
	}
};
